<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="homeVisitData"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Home Visit - Activity</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <!-- export list -->
          <export-list />
          <v-spacer></v-spacer>
          <v-row>
            <v-col class="col--padding" md="7">
              <v-btn
                @click="filterAlert"
                color="warning accent-4"
                depressed
                dark
                class="ml-1 mb-1"
              >
              Adverse Events
              </v-btn>
              <v-btn
                @click="displayCurrentRoute"
                color="teal accent-4"
                depressed
                dark
                class="ml-3"
              >
                <v-icon left dark>mdi-filter-variant</v-icon>View All
              </v-btn>
            </v-col>
            <v-col class="col--padding" lg="5">
              <v-select
                class="mr-3"
                v-model="townshipId"
                placeholder="choose township..."
                hide-details
                outlined
                dense
                item-text="name"
                item-value="id"
                @change="getActivityByTwn"
                :items="townships"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.mdrtb_code }}</td>
          <td>{{ item.mdrtb_year }}</td>
          <td v-if="item.patient">
            {{ item.patient.mdrtb_monopoly=='3'?'SG':item.patient.mdrtb_monopoly=='2'? 'Yes':'No' }}
          </td>
          <td v-else>
            ''
          </td>
          <td>{{ item.month }}</td>
          <td>{{ item.year }}</td>
          <td>{{ item.type == 1 ? "In person" : "By phone" }}</td>
          <td>{{ item.outside_township == 1 ? "No" : "Yes" }}</td>
          <td>{{ item.township.name }}</td>
          <td>
            <span
              :class="{
                'red accent-3': item.comments.length === 0,
                'green accent-3': item.comments.length != 0,
              }"
              class="px-3 py-1 white--text font-weight-bold"
            >
              {{ item.comments.length }}
            </span>
          </td>
          <td>
            {{ +item.checked === 1 ? "Yes" : "No" }}
          </td>
          <td>
            <div class="mr-2">
              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ExportList from "./exportList.vue";

export default {
  props: {
    homeVisitData: {
      type: Array,
    },
  },
  components: {
    ExportList,
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    townshipId: null,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "Code", value: "mdrtb_code" },
      { text: "Year", value: "mdrtb_year" },
      { text: "Mono-poly", value: "monopoly" },
      { text: "Month", value: "month" },
      { text: "Year", value: "year" },
      { text: "Type", value: "type" },
      { text: "Outside Township", value: "outside_township" },
      { text: "Township", value: "township" },
      { text: "Feedbacks", value: "comments" },
      { text: "Checked", value: "checked" },
      { text: "Actions", value: "action" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Township", ["townships"]),
  },
  created() {
    this.$store.dispatch("Township/getTownships");
  },
  methods: {
    filterAlert() {
      this.$store.dispatch("HomeVisit/getAll", {
        month: this.$route.params.month,
        year: this.$route.params.year,
        is_alert: 1,
      });
      this.$router.replace({
        name: "home-visit",
        params: {
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
        query: {
          is_alert: 1,
        },
      });
    },
    displayCurrentRoute() {
      this.$router.push({
        path: this.$route.currentRoute,
        params: {
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
      });
      this.$router.go();
    },
    getActivityByTwn(townshipId) {
      this.$router.push({
        path: this.$route.currentRoute,
        query: { township: townshipId },
      });
      this.$store.dispatch("HomeVisit/getAll", {
        month: this.$route.params.month,
        year: this.$route.params.year,
        township_id: this.$route.query.township,
      });
    },
    goUpdateForm(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "edit-home-visit",
        params: {
          id: convertNumber,
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
      });
    },
  },
};
</script>

<style scoped></style>
